import { gql } from 'graphql-request'

export const GET_LIVE_CHECKINS_MONTHS_TASKS = gql`
  query GET_LIVE_CHECKINS_MONTHS_TASKS(
    $take: Int
    $skip: Int
    $liveCheckinMonthId: Int
    $userId: Int
    $completed: Boolean
  ) {
    getLiveCheckinsMonthsTasks(
      take: $take
      skip: $skip
      liveCheckinMonthId: $liveCheckinMonthId
      userId: $userId
      completed: $completed
    ) {
      status
      error
      totalPages
      data {
        id
        liveCheckinMonthId
        liveCheckinTaskDefaultId
        userId
        liveCheckinTaskType
        targetValue
        quantityCompleted
        pointReward
        pointReceived
        completed
        dateCompleted
      }
    }
  }
`

export const DO_LIVE_CHECKIN = gql`
  mutation DO_LIVE_CHECKIN($userId: Int!) {
    doLiveCheckin(userId: $userId) {
      status
      error
      alreadyToday
    }
  }
`
